var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduce"},[_c('Titles',{attrs:{"title":_vm.data.title}}),_vm._v(" "),_c('UkContent',{attrs:{"content":_vm.data.description,"show-bg":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }